<template>
    <div>
        <van-nav-bar :title="activityTheme" left-text="返回" left-arrow @click-left="onClickLeft"/>
        <van-cell-group>
            <van-field label="活动日期" v-model="startTime" readonly/>
            <van-field required v-model="name" label="姓名" placeholder="请输入姓名" />
            <van-field required v-model="mobile" label="手机号" placeholder="请输入手机号" />
        </van-cell-group>
        <div class="bottom-div">
            <van-button color="red" type="danger" size="large" width="100%" @click="signUp()">提交</van-button>
        </div>
    </div>
</template>

<script>
    import {Field,CellGroup,Button,Cell,Toast, NavBar} from 'vant';
    import {API_URL} from "../common/config";
    import {getKey} from "../utils/url";
    import activityService from "../service/activityService";
    import captchaService from "../service/captchaService";

    export default {
        data: function () {
            return {
                time:60 * 60 * 1000,
                biz:'qr-activity',
                name:'',
                mobile:'',
                code:'',
                activityTheme:'',
                cropId:'',
                activityId:'',
                advisorId:'',
                startTime:'',
                captchaKey:'',
                workUnit:'活动客户'
            }
        },
        computed: {
            captchaSrc() {
                return API_URL + '/crm/captcha/create?biz='+this.biz+"&key=";
            }
        },
        components: {
            [Cell.name]: Cell,
            [Toast.name]: Toast,
            [Field.name]: Field,
            [Button.name]: Button,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar
        },
        created: async function () {
            this.activityTheme = getKey("activityTheme");
            this.startTime = getKey("startTime");
            this.activityId = getKey("activityId");
            this.advisorId = getKey("advisorId");
            this.cropId = getKey("cropId");
            let resp = await captchaService.apply(this.biz);
            if (resp.data.Status === "1"){
                this.captchaKey = resp.data.Data;
            }else {
                Toast.fail(resp.data.Data);
            }
        },
        methods:{
            async signUp() {
                let resp = await activityService.customerReportActivity(this.activityId,this.cropId,this.advisorId,
                    this.name,this.mobile,this.workUnit,
                    this.captchaKey,this.code,this.biz);
                if (resp.data.Status === '1') {
                    this.$router.push("/success?message=报名成功！");
                } else {
                    Toast.fail(resp.data.Message);
                    this.code="";
                    this.codeRefresh();
                }
            },
            async codeRefresh() {
                let resp = await captchaService.apply(this.biz);
                if (resp.data.Status === "1"){
                    this.captchaKey = resp.data.Data;
                }else {
                    Toast.fail(resp.data.Data);
                }
            },
            onClickLeft(){
                this.$router.push("/activityDetail?activityId="+this.activityId+"&cropId="+this.cropId+"&advisorId="+this.advisorId);
            }
        }
    };

</script>
<style scoped>
    .bottom-div{
        position: absolute;
        width: 100%;
        bottom: 0;
    }

    .captcha-container {
        display: flex;
    }

    .captcha {
        height: 2.7rem;
    }

    .van-button--danger{
        color: #fff;
        background-color: #f44;
        border: 1px solid #f44;
    }
</style>
